export const PERIODS = [
  { key: 'coda_della_notte', label: 'Coda della notte', bg: '#e65100', text: '#fff' },
  { key: 'giorno',           label: 'Giorno',           bg: '#1a237e', text: '#fff' },
  { key: 'notte',            label: 'Notte',            bg: '#546e7a', text: '#fff' },
];

export const getPeriod = (key) => PERIODS.find(p => p.key === key) || null;
